module.exports = __webpack_public_path__ + "img/UT_Logo_2400_Sta_White_EN.8ed49ce3.png";